<template>
  <component :is="type" class="iframe-wrapper"><slot /></component>
</template>

<script>
/**
 * Used to build the outer wrapper of a iframe-embedded page.
 * IframeWrapper doesn’t provide customizable options.
 */
export default {
  name: "IframeWrapper",
  status: "ready",
  release: "1.0.0",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div",
    },
  },
};
</script>

<style lang="scss">
@import "../../design-system/assets/tokens/tokens";
.iframe-wrapper {
  @include reset;
  height: 100vh;
  padding-top: 3rem;
  width: 100%;
  @media (min-width-for("md")) {
    width: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 2;
    flex-shrink: 1;
  }
  @media (min-width-for("sm")) {
    padding-top: 4rem;
  }
}
.iframe-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
